import { render } from "./CadastroClienteUsuarios.vue?vue&type=template&id=69206396&scoped=true"
import script from "./CadastroClienteUsuarios.vue?vue&type=script&lang=ts"
export * from "./CadastroClienteUsuarios.vue?vue&type=script&lang=ts"

import "./CadastroClienteUsuarios.vue?vue&type=style&index=0&id=69206396&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-69206396"

export default script